import { stringToSVG } from 'utilities';

import PanelToggle from '../panel-toggle';

import ContentPanel from './content';

import gearIconString from 'assets/images/gear-icon.svg?raw';

const gearIcon = stringToSVG(gearIconString);

class AdvancedColumnsSettingsPanel {

  constructor(configuration) {

    this.menu = configuration.menu;
    this.contentPanel = new ContentPanel(configuration);

    this.panelToggle = new PanelToggle({
      label: 'Advanced',
      icon: gearIcon.cloneNode(true),
      contentPanel: this.contentPanel,
      onExpand: this.menu.repositionMenu.bind(this.menu),
      onCollapse: this.menu.repositionMenu.bind(this.menu)
    });

    this.el = this.panelToggle.el;

  }

  onmount() {
    this.contentPanel.initialize();
  }

  update(configuration) {

    this.contentPanel.update(configuration);

  }

}

export default AdvancedColumnsSettingsPanel;